import type { SeriesStatus } from '../../queries/emailSeries';

// Display helpers shared by the Series list, detail and enrolment views.

export const STATUS_LABELS: Record<SeriesStatus, string> = {
  paused: 'Paused',
  dry_run: 'Dry run',
  live: 'Live',
};

export const STATUS_VARIANTS: Record<SeriesStatus, 'default' | 'warning' | 'success'> = {
  paused: 'default',
  dry_run: 'warning',
  live: 'success',
};

/** Marketing write is super-admin and operations (admin-api rbac/permissions.ts). */
export const canWriteMarketing = (role: string) => role === 'super-admin' || role === 'operations';

export const DRY_RUN_HELP = 'Dry run records who would be sent what, and sends nothing.';

// Series dates are Brisbane-calendar dates (the sweep runs on Brisbane time),
// so they are shown on that calendar whatever the admin's own time zone is.
const DATE_FORMAT = new Intl.DateTimeFormat('en-AU', { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'Australia/Brisbane' });

export function formatSeriesDate(value: string | null | undefined): string {
  if (!value) return '—';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? value : DATE_FORMAT.format(date);
}

const CALENDAR_FORMAT = new Intl.DateTimeFormat('en-AU', { day: 'numeric', month: 'short', year: 'numeric' });

/**
 * A plain 'YYYY-MM-DD' calendar date (trigger dates, discount end dates).
 * Built from its parts as a local date: new Date('YYYY-MM-DD') is UTC
 * midnight, which shows as the day before west of Greenwich.
 */
export function formatCalendarDate(value: string | null | undefined): string {
  if (!value) return '—';
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (!match) return value;
  return CALENDAR_FORMAT.format(new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3])));
}

export function formatSendHour(hour: number): string {
  return `${String(hour).padStart(2, '0')}:00`;
}

export function describeOffer(discountLabel: string | null, codeValidDays: number | null): string {
  if (!discountLabel) return 'No offer chosen';
  return codeValidDays ? `${discountLabel}, code valid ${codeValidDays} day${codeValidDays === 1 ? '' : 's'}` : discountLabel;
}
